module.exports = __webpack_public_path__ + "static/media/add-to-cart.7b9fec68.png";